/**
 * @generated SignedSource<<06f329a4787d481a42a4c55f0b801953>>
 * @relayHash 7d47bdaa4d5aeb847704c6e13c25fd58
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8e680ef9e6d909ed43bf02677fe95ccafcad565518b3a659febcd16aa4f5bbd8

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JiraJqlFunctionStatus = "FINISHED" | "PROCESSING" | "UNKNOWN" | "%future added value";
export type jqlSearchStatus_Query$variables = {
  cloudId: string;
  jql: string;
};
export type jqlSearchStatus_Query$data = {
  readonly jira: {
    readonly issueSearchStatus: {
      readonly functions: ReadonlyArray<{
        readonly app: string | null | undefined;
        readonly function: string;
        readonly status: JiraJqlFunctionStatus;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type jqlSearchStatus_Query = {
  response: jqlSearchStatus_Query$data;
  variables: jqlSearchStatus_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "jql"
  }
],
v1 = [
  {
    "concreteType": "JiraQuery",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Variable",
            "name": "jql",
            "variableName": "jql"
          }
        ],
        "concreteType": "JiraIssueSearchStatus",
        "kind": "LinkedField",
        "name": "issueSearchStatus",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraJqlFunctionProcessingStatus",
            "kind": "LinkedField",
            "name": "functions",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "status"
              },
              {
                "kind": "ScalarField",
                "name": "function"
              },
              {
                "kind": "ScalarField",
                "name": "app"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "jqlSearchStatus_Query",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "jqlSearchStatus_Query",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "8e680ef9e6d909ed43bf02677fe95ccafcad565518b3a659febcd16aa4f5bbd8",
    "metadata": {},
    "name": "jqlSearchStatus_Query",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9dd1bed08ceb0d25df132f36097ae6d1";

export default node;
